import type { ReactElement, SVGProps } from 'react';

export function IconIsometricFlagPt(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 40 40"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.7744 1.14246L23.1768 6.11079L14.1636 11.31L5.56598 16.2691L5.63062 37.3522L8.22561 38.8575L8.1702 17.7836L16.7678 12.8245L25.7718 7.61607L34.3786 2.65697L31.7744 1.14246Z"
        fill="#050505"
      />
      <path
        d="M34.0579 23.5144L16.636 33.574L8.59894 38.2087L8.54523 17.9988L16.9554 13.1404L33.9964 3.30542L34.0579 23.5144Z"
        stroke="#050505"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.75"
      />
      <path
        d="M14.7974 35.0626L14.7981 13.9492L34.201 2.74982L34.329 23.672L14.7974 35.0626Z"
        fill="#EF0000"
      />
      <path
        d="M18.0337 12.0838L18.0331 33.199L8.3316 38.7955L8.33228 17.6891L18.0337 12.0838Z"
        fill="#2F8D00"
      />
      <path
        clipRule="evenodd"
        d="M17.6336 29.6631C17.7596 29.5992 17.8866 29.5304 18.0145 29.4566C18.1579 29.3737 18.3003 29.2859 18.4413 29.1933L18.4414 27.1605C19.3063 26.5985 20.401 25.7365 21.7285 24.5733L22.4777 24.679C22.9328 23.8704 23.3152 23.0207 23.6066 22.1616C23.0003 21.8182 22.415 21.524 21.8503 21.2794C22.5985 20.6825 23.3649 20.0349 24.1495 19.3365L24.0573 18.9874C24.0928 18.9939 24.128 19.001 24.1629 19.0088L24.242 18.8284C24.2444 18.7443 24.2456 18.6606 24.2456 18.5772C24.2456 18.4373 24.2423 18.3003 24.2356 18.1662C23.2214 18.0344 22.0095 18.3767 20.6064 19.1869L20.6063 19.9061C21.8226 19.2038 22.868 18.8864 23.7476 18.9486C22.8877 19.7061 22.0512 20.4 21.2381 21.0304C20.2938 20.6723 19.4102 20.4604 18.5856 20.3954C18.3446 20.3765 18.0925 20.3639 17.8294 20.3576C19.5691 18.9207 21.4694 17.4991 23.5302 16.0929L23.5084 15.8218C23.552 15.8115 23.5959 15.8012 23.6399 15.7911C23.5133 15.5546 23.3686 15.3407 23.2073 15.1503C21.6805 15.5526 20.3917 16.0965 19.3378 16.7867L19.3785 17.4808C20.229 16.9238 21.264 16.4613 22.4814 16.0963C20.6215 17.4026 18.8954 18.7237 17.3031 20.0597C17.191 20.1537 17.0743 20.2536 16.9528 20.3593C15.8111 20.3883 14.4937 20.5182 12.9997 20.7485C12.8312 21.1123 12.6779 21.4813 12.5413 21.8529L12.3544 22.5693C12.4891 22.548 12.6224 22.5275 12.7541 22.5079L12.2948 23.3144L13.2733 23.8834C12.8066 24.3558 12.3126 24.8621 11.7915 25.4023C11.7864 25.5264 11.7838 25.6499 11.7838 25.7726C11.7838 25.8002 11.7839 25.8276 11.7841 25.855L11.8799 26.0834L12.0195 25.9386L11.9208 26.3954C14.3577 25.8099 16.4899 24.9474 18.3193 23.804C18.874 23.4573 19.4405 23.0776 20.0188 22.665C20.3162 22.7676 20.6214 22.8866 20.9342 23.0218L20.3846 24.3837L20.9921 24.4694C19.7389 25.5377 18.734 26.2898 17.981 26.7246C16.8995 27.3491 15.3594 27.9399 13.3681 28.4909C13.4665 28.369 13.5688 28.2459 13.6745 28.123C14.2882 27.4092 14.8963 26.8364 15.4501 26.4972C15.4761 26.4813 15.5019 26.4659 15.5276 26.4511L15.5276 25.7319C15.4957 25.7503 15.4637 25.7693 15.4316 25.789C14.7745 26.1915 14.0856 26.8405 13.3987 27.6393C13.1494 27.9294 12.9176 28.2195 12.7089 28.4966C12.6276 28.6046 12.5606 28.696 12.5094 28.7673C12.6063 28.9244 12.712 29.07 12.826 29.204C12.836 29.1898 12.8492 29.1712 12.8653 29.1487C12.9158 29.0784 12.9747 28.9982 13.0413 28.9098C13.0963 28.8368 13.1531 28.7627 13.2116 28.6879L13.0887 29.3106C14.986 28.7921 16.499 28.2354 17.6337 27.6356L17.6336 29.6631ZM14.4553 22.2918L14.6972 22.4325L14.6558 22.5053C14.7451 22.4178 14.8331 22.3319 14.9198 22.2477C14.7677 22.2609 14.6128 22.2756 14.4553 22.2918ZM12.4199 25.5248C13.7204 24.1845 14.8377 23.0718 15.7707 22.1874C16.5673 22.1448 17.2797 22.1483 17.9076 22.1978C18.3483 22.2325 18.8121 22.3146 19.2985 22.4441C18.9593 22.6749 18.6245 22.8934 18.2943 23.0998C16.6187 24.1471 14.66 24.9565 12.4199 25.5248Z"
        fill="#FFE017"
        fillRule="evenodd"
      />
      <path
        d="M18.4395 15.0233L17.6317 15.4896L17.6317 18.0067L18.4394 17.5404L18.4395 15.0233Z"
        fill="#FFE017"
      />
      <path
        clipRule="evenodd"
        d="M11.7847 25.7721C11.7846 29.7936 14.5742 31.443 18.0154 29.456C21.4567 27.4691 24.2465 22.5982 24.2466 18.5767C24.2467 14.5551 21.4571 12.9057 18.0159 14.8927C14.5746 16.8796 11.7849 21.7505 11.7847 25.7721ZM23.4718 19.1189C23.4717 22.5943 21.0608 26.8037 18.0868 28.5208C15.1129 30.2379 12.7022 28.8125 12.7023 25.3371C12.7024 21.8617 15.1133 17.6523 18.0872 15.9352C21.0612 14.2181 23.4719 15.6434 23.4718 19.1189Z"
        fill="#F9E813"
        fillRule="evenodd"
      />
      <path
        d="M14.6374 20.0476L21.4349 16.1229L21.4347 21.6535L21.429 21.693C21.1006 23.9744 19.9365 25.747 18.0359 26.8444C16.1353 27.9418 14.9712 27.5134 14.643 25.6112L14.6373 25.5783L14.6374 20.0476Z"
        fill="white"
      />
      <path
        clipRule="evenodd"
        d="M14.1422 25.6666C14.1421 27.9598 15.6734 28.9345 18.0533 27.5604C20.4332 26.1862 21.9646 23.4431 21.9647 21.15L21.9649 15.1209L14.1424 19.6376L14.1422 25.6666ZM15.9155 20.6613L15.9154 24.6428C15.9154 25.805 16.8498 26.2077 18.0534 25.5128C19.2569 24.8178 20.1914 23.3361 20.1914 22.1738L20.1916 18.1924L15.9155 20.6613Z"
        fill="#C51918"
        fillRule="evenodd"
      />
      <path
        d="M17.4899 20.2059L18.4761 19.6365L18.4761 20.4618C18.4761 20.4618 18.4029 20.9302 17.983 21.1727C17.5631 21.4151 17.4899 21.0312 17.4899 21.0312L17.4899 20.2059Z"
        fill="#013399"
      />
      <path
        d="M17.4899 22.0265L18.476 21.4571L18.476 22.2824C18.476 22.2824 18.4028 22.7508 17.9829 22.9933C17.563 23.2357 17.4899 22.8518 17.4899 22.8518L17.4899 22.0265Z"
        fill="#013399"
      />
      <path
        d="M18.7709 21.2857L19.757 20.7163L19.757 21.5416C19.757 21.5416 19.6838 22.01 19.2639 22.2525C18.844 22.4949 18.7708 22.111 18.7708 22.111L18.7709 21.2857Z"
        fill="#013399"
      />
      <path
        d="M16.2105 22.7652L17.1967 22.1958L17.1967 23.0211C17.1967 23.0211 17.1235 23.4895 16.7036 23.732C16.2837 23.9744 16.2105 23.5905 16.2105 23.5905L16.2105 22.7652Z"
        fill="#013399"
      />
      <path
        d="M17.49 23.8459L18.4762 23.2765L18.4761 24.1017C18.4761 24.1017 18.4029 24.5702 17.983 24.8126C17.5632 25.055 17.49 24.6711 17.49 24.6711L17.49 23.8459Z"
        fill="#013399"
      />
      <path
        d="M18.5752 17.4174L17.393 18.0999L17.393 19.465L18.5751 18.7824L18.5752 17.4174Z"
        fill="#F9E813"
      />
      <path
        d="M21.6226 15.658L20.4405 16.3406L20.4404 17.7057L21.6226 17.0231L21.6226 15.658Z"
        fill="#F9E813"
      />
      <path
        d="M21.6246 18.9615L20.4425 19.6441L20.4424 21.0092L21.6246 20.3266L21.6246 18.9615Z"
        fill="#F9E813"
      />
      <path
        d="M21.3607 22.8993L20.3717 22.7224L19.724 24.2384L20.713 24.4152L21.3607 22.8993Z"
        fill="#F9E813"
      />
      <path
        d="M15.5187 19.1827L14.3366 19.8653L14.3365 21.2303L15.5187 20.5478L15.5187 19.1827Z"
        fill="#F9E813"
      />
      <path
        d="M15.5167 22.4882L14.3346 23.1708L14.3345 24.5358L15.5167 23.8532L15.5167 22.4882Z"
        fill="#F9E813"
      />
      <path
        d="M15.5865 25.4761L14.5976 26.795L15.2453 27.563L16.2342 26.244L15.5865 25.4761Z"
        fill="#F9E813"
      />
      <path
        d="M34.0572 23.5135L16.6353 33.5731L8.59821 38.2079L8.54449 17.9979L16.9547 13.1395L33.9957 3.30457L34.0572 23.5135Z"
        stroke="#050505"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.75"
      />
    </svg>
  );
}
